import { http } from '../shared/api';

export const getHistoricalReports = (config = {}) => http.get(
  '/api/emissions/historical-reports',
  config,
);

export const getHistoricalReport = (fiscalYear, config = {}) => http.get(
  `/api/emissions/historical-reports/${Number(fiscalYear)}`,
  config,
);
